var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHorizontalLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "149px",
    height: "30px",
    viewBox: "0 0 149 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6BA73DBF-96B2-4E6C-A5E8-22DCAFED72A1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 148.846154,
    height: 30
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "36.8498171%",
    y1: "16.4632271%",
    x2: "69.2336159%",
    y2: "83.2486362%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A38138",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A38138",
    stopOpacity: 0.25,
    offset: "77.2809222%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A38138",
    stopOpacity: 0.1,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "36.9681806%",
    y1: "16.4632271%",
    x2: "69.060496%",
    y2: "83.2486362%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A38138",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A38138",
    stopOpacity: 0.25,
    offset: "77.2809222%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A38138",
    stopOpacity: 0.1,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "App-frame---Desktop-HD-v2.2",
    transform: "translate(-19.000000, -13.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo-horizontal",
    transform: "translate(19.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5635864,21.7 C46.3832236,21.7 48.1877914,20.3430769 48.1877914,18.0330769 C48.1877914,16.45 47.5271907,15.5130769 45.2231443,14.6892308 L44.6592169,14.4792308 C43.1446689,13.9461538 42.774088,13.6230769 42.774088,12.8961538 C42.774088,12.1853846 43.2896788,11.7169231 44.4819826,11.7169231 C45.5615008,11.7169231 46.9793755,12.1369231 47.7366495,12.5407692 L47.4627419,10.0853846 C46.7699167,9.73 45.577613,9.39076923 44.288636,9.39076923 C41.5656721,9.39076923 40.0511241,10.6346154 40.0511241,12.9769231 C40.0511241,14.8507692 41.0823057,15.7230769 43.2091178,16.45 L43.9341673,16.7084615 C45.1748077,17.1284615 45.4487153,17.5 45.4487153,18.0653846 C45.4487153,18.8569231 44.8364512,19.39 43.5152498,19.39 C42.2584972,19.39 40.8245103,19.0184615 39.6805432,18.4046154 L39.970563,20.9569231 C40.953408,21.4576923 42.2584972,21.7 43.5635864,21.7 Z M58.1451388,21.5384615 L58.1451388,9.64923077 L55.4221749,9.64923077 L55.4221749,21.5384615 L58.1451388,21.5384615 Z M68.4247304,21.5384615 L68.4247304,14.6892308 L72.1627637,21.5384615 L72.3561102,21.5384615 L76.1424802,14.6730769 L76.1424802,21.5384615 L78.6559853,21.5384615 L78.6559853,9.64923077 L76.4647244,9.64923077 L72.3883347,17.1123077 L68.3441693,9.64923077 L66.0240107,9.64923077 L66.0240107,21.5384615 L68.4247304,21.5384615 Z M89.241709,21.5384615 L89.241709,9.64923077 L86.518745,9.64923077 L86.518745,21.5384615 L89.241709,21.5384615 Z M99.5857494,21.5384615 L99.5857494,18.2592308 L101.374205,18.2592308 L101.374205,18.2592308 L103.420456,21.5384615 L106.707347,21.5384615 L103.968271,17.4353846 C105.047789,16.6761538 105.724502,15.4646154 105.724502,13.9623077 C105.724502,11.1676923 103.758812,9.64923077 101.084185,9.64923077 L96.9433466,9.64923077 L96.9433466,21.5384615 L99.5857494,21.5384615 Z M100.53637,16.4984615 L99.5857494,16.4984615 L99.5857494,11.9592308 L100.53637,11.9592308 C102.163703,11.9592308 102.969314,12.7830769 102.969314,14.2692308 C102.969314,15.7392308 102.21204,16.4984615 100.53637,16.4984615 Z M116.213553,21.5384615 L116.213553,9.64923077 L113.490589,9.64923077 L113.490589,21.5384615 L116.213553,21.5384615 Z M129.022762,21.5384615 L129.022762,12.2338462 L132.229092,12.2338462 L132.229092,9.64923077 L123.174029,9.64923077 L123.174029,12.2338462 L126.364247,12.2338462 L126.364247,21.5384615 L129.022762,21.5384615 Z M144.748281,21.5384615 L144.748281,17.6615385 L148.679661,9.64923077 L145.827799,9.64923077 L143.539865,15.1738462 L141.155258,9.64923077 L137.981152,9.64923077 L142.025317,17.6615385 L142.025317,21.5384615 L144.748281,21.5384615 Z",
    id: "SIMIRITY",
    fill: "#17243D",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.779060, 15.078197) rotate(60.000000) translate(-15.779060, -15.078197) translate(-10.778424, -11.490411)",
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.557485, 26.568608) rotate(-54.000000) translate(-26.557485, -26.568608) translate(7.515305, 7.576705)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(23.634084, 21.830159) rotate(-330.000000) translate(-23.634084, -21.830159) translate(14.759118, 8.301498)",
    fill: "url(#linearGradient-3)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.40673143,-4.50921352e-14 C5.3867902,0.0493868619 6.35078085,0.118722142 7.26443762,0.369142583 C8.20519724,0.626922635 9.10268909,0.939028235 9.94558803,1.38525306 C12.5873425,2.89658787 14.8788893,4.86450906 16.1808913,7.56906919 C17.3661575,10.03144 18.0660888,12.7298026 17.6086313,15.6308449 C17.1128425,19.1275026 15.390359,22.0097392 12.8526601,24.0803269 C10.5287835,25.9764241 7.6332301,27.2356535 4.40673143,27.0366923 C1.27685445,26.9940259 1.31683117,26.8133184 4.40673143,26.771204 C7.4099219,26.586013 10.1294035,25.2847369 11.8935093,23.1207886 C13.5401048,21.1009725 14.1358838,18.4126907 13.7414404,15.6308449 C13.4453416,13.7531758 12.4416646,12.2542362 11.2321027,10.9639802 C10.1346305,9.79322104 8.62248449,9.21946191 7.03570884,8.85884098 L4.47797323,8.71920205 L4.35843026,8.72046093 C1.95293529,8.72046093 0,6.76677477 0,4.36027888 C0,1.95378299 1.95293529,-4.50921352e-14 4.35843026,-4.50921352e-14 L4.40673143,-4.50921352e-14 Z",
    id: "Fill-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(14.415608, 16.133631) scale(-1, -1) rotate(-330.000000) translate(-14.415608, -16.133631) translate(5.580674, 2.604970)",
    fill: "url(#linearGradient-4)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.38685432,4.91914202e-14 C5.36249242,0.0493868619 6.32213487,0.118722142 7.23167047,0.369142583 C8.16818669,0.626922635 9.06163029,0.939028235 9.90072723,1.38525306 C12.5305657,2.89658787 14.8117762,4.86450906 16.1079054,7.56906919 C17.2878253,10.03144 17.9845995,12.7298026 17.5292054,15.6308449 C17.0356529,19.1275026 15.3209389,22.0097392 12.7946866,24.0803269 C10.4812921,25.9764241 7.59879948,27.2356535 4.38685432,27.0366923 C1.27109504,26.9940259 1.31089144,26.8133184 4.38685432,26.771204 C7.37649853,26.586013 10.0837136,25.2847369 11.8398622,23.1207886 C13.4790305,21.1009725 14.0721221,18.4126907 13.6794579,15.6308449 C13.3846947,13.7531758 12.385545,12.2542362 11.1814389,10.9639802 C10.088917,9.79322104 8.58359171,9.21946191 7.00397341,8.85884098 L4.45777478,8.71920205 L4.33877102,8.72046093 C1.94412633,8.72046093 0,6.76677477 0,4.36027888 C0,1.95378299 1.94412633,4.91914202e-14 4.33877102,4.91914202e-14 L4.38685432,4.91914202e-14 Z",
    id: "Fill-1"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontalLogo);
export default __webpack_public_path__ + "static/media/horizontal-logo.56278d4a3211aebd8a3b1288df70b91c.svg";
export { ForwardRef as ReactComponent };